<template>
    <div>
        <p class="timeline-talks">{{ message }} 
            <span v-if="this.details.data"> 
                <strong>Client Activation Date:</strong> {{ this.details.data[0].date }}
                <br>
                <strong>Reason:</strong> {{ this.details.data[0].reason }}
            </span>
        </p>
        <div class="timeline-component">
            <p v-if="details.purposeOfProcessing" ><strong>Purpose of Processing : </strong>{{details.purposeOfProcessing}}</p>
            <p v-if="details.userId" ><strong> Action By : </strong>{{details.user.firstName}} {{details.user.lastName}} ({{details.user.role.title}})</p>
            <p v-else ><strong> Action By : </strong>Idenfo System</p>
            <p v-if="details.legalBasisForProcessing" ><strong>Legal Basis for Processing : </strong>{{details.legalBasisForProcessing}}</p>
            <p v-if="details.retentionPeriod" ><strong>Retention Period : </strong>{{details.retentionPeriod}}</p>
        </div>
    </div>
</template>

<script>
//import tags from '@/components/Tags.vue'

export default {
    // components: {
    //     tags,
    // },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: ['details'],
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        message() {
            return this.details.action
        },
    },
}
</script>
